import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { isUserBuyerGroup, getUserLogged } from "@/js/http/auth.js";
export default {
  name: "WholesalersData",
  props: {
    loggedUserData: Object,
    centered: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {
      dialog: false,
      isBuyerUsa: false
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var userLogged;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isUserBuyerGroup(_this.loggedUserData)) {
              _context.next = 11;
              break;
            }
            _context.prev = 1;
            _context.next = 4;
            return getUserLogged();
          case 4:
            userLogged = _context.sent;
            _this.isBuyerUsa = userLogged.delivery_address.country.iso_code === "USA";
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            //In doubt, we show the legal information
            _this.isBuyerUsa = true;
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }))();
  }
};